import React, { useState } from "react";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AccountBalance from "@material-ui/icons/AccountBalance";
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";

import "./SearchResults.css";

function displayClass(result: any) {
  if (result.companyResult) {
    return "SearchResult-itemCompany";
  }
  if (result.branchResult) {
    return "SearchResult-itemBranch";
  }
  return "SearchResult-itemUser";
}

const SearchResults = (props: any) => {
  const [selectedIndex, setSelectedIndex] = useState<string>();

  return (
    <div
      className={`SearchResults-container ${
        props.className ? props.className : ""
      }`}
    >
      {props.results &&
        props.results.map((r: any) => {
          const key = r.companyId + "/" + r.branchId + "/" + r.userId;
          return (
            <div
              className={`SearchResult-item ${displayClass(r)} ${
                key === selectedIndex ? "SearchResult-item-selected" : ""
              }`}
              onClick={() => {
                setSelectedIndex(key);
                if (r.companyResult) {
                  props.onSelectCompany(r.companyId);
                }
                if (r.branchResult) {
                  props.onSelectBranch(r.companyId, r.branchId);
                }
                if (r.userResult) {
                  props.onSelectUser(r.companyId, r.userId);
                }
              }}
            >
              {r.companyResult ? (
                <AccountBalance style={{ float: "left", paddingRight: 4 }} />
              ) : r.branchResult ? (
                <StoreMallDirectory
                  style={{ float: "left", paddingRight: 4 }}
                />
              ) : (
                <AccountCircle style={{ float: "left", paddingRight: 4 }} />
              )}
              <div className="SearchResult-userName">{r.userName}</div>
              <div className="SearchResult-branchName">{r.branchName}</div>
              <div className="SearchResult-companyName">{r.companyName}</div>
            </div>
          );
        })}
    </div>
  );
};

export default SearchResults;
